'use strict';

export default {
  userMenu: {
    logout: 'Logout',
    notifications: 'Notifications',
  },
};
